import { get, post } from '@/tools/http';

export const limitSessions = 10;

const createEventStatusIfNoExists = (sessions, key, event, status) => {
    if (!sessions[key]) sessions[key] = {};
    if (!sessions[key][event]) sessions[key][event] = {};

    if (!sessions[key][event][status])
        sessions[key][event][status] = { pages: {}, total: 0, needFeedback: 0 };

    return sessions;
};

export default {
    namespaced: true,
    state: {
        totalEvents: 0,
        events: {},
        sessions: {},
        workSession: null,
        reviews: {},
        reviewSessions: {},
        reviewSessionId: null,
        reviewExperts: {},
        pageSize: limitSessions,
        loading: {
            events: false,
            sessionsneed_check:false,
            sessionsin_check:false,
            sessionscompleted:false,
            sessionsposted:false,
        },
    },
    mutations: {
        writeEvents(state, { key, items, total }) {
            state.events = {
                ...state.events,
                [key]: {
                    items,
                    updatedAt: Date.now(),
                },
            };
            state.totalEvents = total;
        },
        writeSessions(state, { key, event, status, page, total, needFeedback, items }) {
            const args = [{ ...state.sessions }, key, event, status];
            const sessions = createEventStatusIfNoExists(...args);

            sessions[key][event][status].total = total;
            sessions[key][event][status].needFeedback = needFeedback;
            sessions[key][event][status].pages[page] = {
                items,
                updatedAt: Date.now(),
            };

            state.sessions = sessions;
        },
        unloadSessions(state) {
            state.sessions = {};
        },
        writeWorkSession(state, res) {
            state.workSession = res;
        },
        unloadReviews(state) {
            state.reviews = {};
        },
        unloadReviewSessions(state) {
            state.reviewSessions = {};
        },
        writeReview(state, res) {
            state.reviews = {...state.review, [res.id]: res};
        },
        writeReviewExperts(state, res) {
            state.reviewExperts = {...state.reviewExperts, [res.id]: res.experts};
        },
        writeReviewSession(state, res) {
            state.reviewSessions = {...state.reviewSessions, [res.id]: res};
            state.reviewSessionId = res.id;
        },
        setLoading(state, {type, value}) {
            state.loading = {...state.loading, [type]: value};
        },
    },
    actions: {
        async loadEvents(ctx) {
            const now = Date.now();

            const event = ctx.state.events.review;

            if (event && (event.updatedAt + 60e3) > now) return false;

            ctx.commit('setLoading', {type: 'events', value: true});
            const res = await get('examination', `expert/event/review`);
            ctx.commit('setLoading', {type: 'events', value: false});

            if (!res) return false;

            ctx.commit('writeEvents', { key: 'review', items: res.items , total: res.total });
            return true;
        },
        async loadSessions(ctx, { key, event, status, page, pageSize, id, userId, onlyNeedFeedback, scoreMin, scoreMax }) {
            const params = {
                limit: pageSize || limitSessions,
                offset: (page - 1) * (pageSize || limitSessions),
                'filter[id]': id,
                'filter[userId]': userId,
                'filter[onlyNeedFeedback]': onlyNeedFeedback,
                'filter[scoreMin]': scoreMin,
                'filter[scoreMax]': scoreMax,
            };
            if (status === 'completed' || status === 'posted') {
                params['sort[0][column]'] = 'score';
                params['sort[0][order]'] = 'desc';
            }

            const path = `expert/event/${key}/${event}/sessions/${status}`;

            ctx.commit('setLoading', {type: `sessions${status}`, value: true});
            const res = await get('examination', path, params);
            ctx.commit('setLoading', {type: `sessions${status}`, value: false});

            if (!res) return;

            await ctx.dispatch('users/loadMany', res.items.map(i => i.userId), {root: true});

            const args = {
                key,
                event,
                status,
                page,
                total: res.total,
                needFeedback: res.need_feedback || 0,
                items: res.items,
            };

            ctx.commit('writeSessions', { ...args });

        },
        unloadSessions(ctx) {
            ctx.commit('unloadSessions');
        },
        async loadWorkSession(ctx, { type, eid, sid, isSuper }) {
            const path = `expert/event/${type}/${eid}/sessions/${sid}/start${isSuper ? '/super' : ''}`;
            try {
                const res = await post('examination', path, {}, false, {}, true, true);

                if (!res) return false;

                if (res.data.userId) {
                    ctx.dispatch('users/loadOne', res.data.userId, { root: true });
                }

                ctx.commit('writeWorkSession', res.data);
            } catch (e) {
            }

            return true;
        },
        unloadReviews(ctx) {
            ctx.commit('unloadReviews');
        },
        unloadReviewSessions(ctx) {
            ctx.commit('unloadReviewSessions');
        },
        async loadReview(ctx, id) {
            const path = `review/${id}`;
            const res = await get('examination', path);

            ctx.commit('writeReview', res);
        },
        async loadReviewExperts(ctx, id) {
            const path = `expert/event/review/${id}/experts`;
            const res = await get('examination', path);

            ctx.commit('writeReviewExperts', {id, experts: (res && res.items) || []});
        },
        async loadReviewSession(ctx, {reviewId, activitySessionId, isSuper}) {
            const path = `expert/event/review/${reviewId}/session/${activitySessionId}`;
            const res = await get('examination', path, isSuper ? {
                isSuper: true,
            } : {});

            if (res) {
                ctx.commit('writeReviewSession', res);
            }
        },
        async saveReviewSession(ctx, params) {
            const path = `expert/event/review/${params.reviewId}/session/${params.activitySessionId}`;
            const res = await post('examination', path, params.data, true);
            return res;
        },
    },
    getters: {
        mainTabs: () => tabs,
        limitSessions: () => limitSessions,
        pagesCount: state => (total, pageSize) => Math.ceil(total / pageSize),
        review: state => id => state.reviews[id],
        reviewSession: state => id => state.reviewSessions[id],
        currentReviewSession: state => state.reviewSessions[state.reviewSessionId],
        reviewExperts: state => id => state.reviewExperts[id],
        getLoading: state => type => state.loading[type],
        totalEvents: state => state.totalEvents,
    },
};
